import { Box, Flex, Icon, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaComment } from "react-icons/fa";
import { BseQuestionDto } from "../../../../../autogen/bff-api";
import { displayWrappedWithEllipsis } from "../../../../../common/formatting/displayWrappedWithEllipsis";
import { QuestionStatusTag } from "../../../buyer/view-single/questions/QuestionStatusTag";

interface Props {
  items: BseQuestionDto[];
  getInfoSentence: (q: BseQuestionDto) => string;
  onRowClick: (id: string) => void;
  bordered?: boolean;
  emptyText: string;
}

export const QuestionsTable = ({ items, getInfoSentence, onRowClick, bordered = false, emptyText }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex
      flexDirection="column"
      backgroundColor="smBackground"
      pt="5"
      pb="2.5"
      border={bordered ? "1px solid" : undefined}
      borderColor={bordered ? "smBorder" : undefined}
      rounded={bordered ? "md" : undefined}
      boxShadow={bordered ? "sm" : undefined}
    >
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>{t("Subject")}</Th>
            <Th textAlign="center">{t("Status")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((e) => (
            <Tr cursor={"pointer"} _hover={{ bg: "smBackgroundSecondary" }} key={e.id} onClick={() => onRowClick(e.id)}>
              <Td>
                <Box>{displayWrappedWithEllipsis(e.subject, 60)}</Box>
                <Box fontSize="sm" color="smMuted" pt="1">
                  {getInfoSentence(e)}
                </Box>
              </Td>
              <Td textAlign="center">
                <QuestionStatusTag status={e.status} />
                <Flex alignItems="center" justifyContent="center" fontWeight="semibold" pt="1">
                  {e.comments.length}
                  <Icon as={FaComment} color="smMuted" ml="2" />
                </Flex>
              </Td>
            </Tr>
          ))}
          {items.length === 0 && (
            <Tr>
              <Td colSpan={4} width={"100%"} textAlign="center">
                {emptyText}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Flex>
  );
};
